import { getValueReduxUtil } from '../../../../redux'
import { USER_KEY } from '../../constants'

export function getSubscriptionPlansUserUtil (user) {
  return getValueReduxUtil(user, USER_KEY.SUBSCRIPTION_PLANS) || []
}
